import { forwardRef, useEffect, useState } from 'react';
import { Transition } from '@headlessui/react';
import clsx from 'clsx';

import { IconCloseCircleOutline } from '@hubii/icons';
import { statusClasses, ToastProps } from './data';

const Toast = forwardRef<HTMLDivElement, ToastProps>((props: ToastProps, ref) => {
  const { status = 'info', message, duration = 5000, icon, actions } = props;

  const [visible, setVisibility] = useState(!!message);

  useEffect(() => {
    setVisibility(!!message);
    setTimeout(() => {
      setVisibility(false);
    }, duration);
  }, [message, duration]);

  return (
    <Transition
      as='div'
      ref={ref}
      show={visible}
      className={`fixed z-50 bottom-0 p-4 transform left-1/2 -translate-x-1/2`}
      style={{ transitionDuration: `${duration}ms` }}
      enterFrom='translate-y-full'
      enterTo='translate-y-0'
      enter='!duration-100'
      leaveFrom='translate-y-0'
      leaveTo='translate-y-full'
      leave='!duration-100'
      unmount
    >
      <div
        className={clsx(
          'flex items-center justify-between rounded-md p-3 md:p-4 w-full min-w-80 md:min-w-48 shadow-md',
          statusClasses[status],
        )}
      >
        <div className='flex items-center justify-between gap-2 text-sm md:text-base'>
          {icon && <div className='min-w-6 mr-2'>{icon}</div>}
          {message}
        </div>

        <div className='flex items-center justify-between gap-2 ml-2'>
          {actions}
          <IconCloseCircleOutline className='w-6 h-6 cursor-pointer' onClick={() => setVisibility(false)} />
        </div>
      </div>
    </Transition>
  );
});

Toast.displayName = 'Toast';
export default Toast;
